import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Rilevazione } from '../models/rilevazione-presenze/rilevazione';
import { Studente } from '../models/didattica/studente';

@Injectable({ providedIn: 'root' })
export class EventsService {

  public login = new Subject<void>();
  public logout = new Subject<LogoutEventData | void>();
  public geolocIsActive = new Subject<any>();
  public backFromElencoPresenti = new Subject<void>();
  public presenzeUpdated = new Subject<void>();
  public order = new Subject<OrderEventData | void>();
  public paginaPrecedente = new Subject<string>();
  public reloadRils = new Subject<string>();
  public reloadArRils = new Subject<string>();
  public addRil = new Subject<Rilevazione>();
  public reloadDeleghe = new Subject<void>();
  public verificaDisattivata = new Subject<void>();
  public delegaNewdelega = new Subject<void>();
  public confermeUpdated = new Subject<void>();
  public recuperiUpdated = new Subject<void>();
  public richiesteGiustificaUpdated = new Subject<void>();
  public errorCreatingPresenza = new Subject<Studente>();
  public showError = new Subject<void>();

}

export interface LogoutEventData {
  authExpired?: boolean;
  fromGuard?: boolean;
}
export interface OrderEventData {
  field: string;
  ascdesc: string;
}
